import * as React from "react";
import { SVGProps } from "react";

const HavenProtocol = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 288" {...props}>
    <path
      fillRule="evenodd"
      d="M168 92.6 24 175.7V264h48v-67.9l144-83.2V24h-48v68.6zm-23.9-13.8L144 0h96v126.7L95.7 209.9l.3.2V288H0V162l144.1-83.2zM0 134.2V0h96v78.8L72 92.6V24H24v96.3L0 134.2zm144 75.9 24-14.1v68h48v-96l24-13.9V288h-96v-77.9z"
      clipRule="evenodd"
    />
  </svg>
);

export default HavenProtocol;
